function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3125 5.9043L15.8125 7.34375V4.375C15.8125 3.68555 15.252 3.125 14.5625 3.125H3C2.31055 3.125 1.75 3.68555 1.75 4.375V15.625C1.75 16.3145 2.31055 16.875 3 16.875H14.5625C15.252 16.875 15.8125 16.3145 15.8125 15.625V12.6562L18.3125 14.0957C18.7285 14.3359 19.25 14.0352 19.25 13.5566V6.44531C19.25 5.96484 18.7285 5.66406 18.3125 5.9043ZM6.90625 6.875C6.90625 6.96094 6.83594 7.03125 6.75 7.03125H4.5625C4.47656 7.03125 4.40625 6.96094 4.40625 6.875V5.9375C4.40625 5.85156 4.47656 5.78125 4.5625 5.78125H6.75C6.83594 5.78125 6.90625 5.85156 6.90625 5.9375V6.875ZM17.8438 12.207L15.8125 11.0391V8.96289L17.8438 7.79297V12.207Z",
  fill: "#15A9E1"
});

var SvgVideoCamera = function SvgVideoCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video-camera.9087d609.svg";
export { ForwardRef as ReactComponent };